import { render, staticRenderFns } from "./TypeBound.vue?vue&type=template&id=21312944&scoped=true&"
import script from "./TypeBound.vue?vue&type=script&lang=js&"
export * from "./TypeBound.vue?vue&type=script&lang=js&"
import style0 from "./TypeBound.vue?vue&type=style&index=0&id=21312944&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21312944",
  null
  
)

export default component.exports